module.exports = require('../_components/@alicd/next-rating/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/rating/index.js
// module id = 663
// module chunks = 0